<div [ngClass]="isInvalid ? 'invalid' : ''" class="form-container">
  <app-input-label
    [for]="for"
    [label]="label"
    [biggerFont]="biggerFont!"
    [inputContainer]="inputContainer"
    [isRequired]="isRequired"
    [popoverInfo]="popoverInfo"
  ></app-input-label>
  <div #inputContainer class="radio-buttons">
    <ng-content></ng-content>
  </div>
  <div
    *ngFor="let info of expandableInfo; let i = index"
    class="mt-2"
  >
    <button
      type="button"
      class="btn d-flex align-items-center gap-2 p-0 fw-bold text-start"
      [attr.aria-controls]="expandableInfoId(i)"
      [attr.aria-expanded]="isExpandableInfoExpanded(i)"
      (click)="toggleExpandableInfo(i)"
    >
      {{ info.title | msg | async }}
      <svg-icon
        src="assets/images/icons/arrow-down.svg"
        [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"
        [ngClass]="{ expanded: isExpandableInfoExpanded(i) }"
      ></svg-icon>
    </button>

    <div
      class="mt-2"
      [id]="expandableInfoId(i)"
      [hidden]="!isExpandableInfoExpanded(i)"
    >
      <p *ngIf="info.description" class="mb-1">
        {{ info.description | msg | async }}
      </p>
      <ul *ngIf="info.items" class="mb-2 ps-4">
        <li *ngFor="let item of info.items">
          {{ item | msg | async }}
        </li>
      </ul>
    </div>
  </div>
  <app-validation
    [hidden]="isValid"
    [validationMessages]="validationMessages"
  ></app-validation>
</div>
